import * as React from 'react'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

const textareaVariants = cva(
  'block w-full appearance-none rounded-md border bg-white text-gray-900 placeholder-gray-400 transition-colors focus-visible:outline-none focus-visible:ring-2 disabled:cursor-not-allowed disabled:opacity-60 dark:bg-gray-900 dark:text-gray-100 dark:placeholder-gray-500',
  {
    variants: {
      variant: {
        default:
          'border-gray-300 hover:border-gray-400 focus-visible:border-primary-500 focus-visible:ring-primary-500/20 dark:border-gray-700 dark:hover:border-gray-600',
        error:
          'border-red-500 focus-visible:border-red-500 focus-visible:ring-red-500/20 dark:border-red-500',
        success:
          'border-green-500 focus-visible:border-green-500 focus-visible:ring-green-500/20 dark:border-green-500',
      },
      resize: {
        none: 'resize-none',
        vertical: 'resize-y',
        horizontal: 'resize-x',
        both: 'resize',
      },
    },
    defaultVariants: { variant: 'default', resize: 'vertical' },
  }
)

export interface TextareaProps
  extends
    React.TextareaHTMLAttributes<HTMLTextAreaElement>,
    VariantProps<typeof textareaVariants> {}

export const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, variant, resize, rows = 3, ...rest }, ref) => (
    <textarea
      ref={ref}
      rows={rows}
      className={cn(
        'px-3 py-2 text-sm',
        textareaVariants({ variant, resize, className })
      )}
      {...rest}
    />
  )
)

Textarea.displayName = 'Textarea'

export { textareaVariants }
